"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SidePanel_1 = require("../SidePanel");
exports.PageWizardPanelContext = react_1.createContext({
    activate: function () {
        // no-op
    },
    deactivate: function () {
        // no-op
    },
    element: null,
    isShrink: false
});
function PageWizardPanelProvider(_a) {
    var children = _a.children;
    var _b = react_1.useState(null), element = _b[0], setPanel = _b[1];
    var _c = react_1.useState(false), isShrink = _c[0], setIsShrink = _c[1];
    var deactivate = react_1.useCallback(function () {
        setPanel(null);
    }, []);
    var activate = react_1.useCallback(function (el, config) {
        setPanel(el);
        setIsShrink(!!(config === null || config === void 0 ? void 0 : config.isShrink));
    }, []);
    return react_1.default.createElement(exports.PageWizardPanelContext.Provider, {
        value: { deactivate: deactivate, activate: activate, element: element, isShrink: isShrink }
    }, children);
}
exports.PageWizardPanelProvider = PageWizardPanelProvider;
function usePageWizardPanel(_a) {
    var title = _a.title, description = _a.description, shrink = _a.shrink, onClose = _a.onClose, render = _a.render;
    var panelApi = react_1.useContext(exports.PageWizardPanelContext);
    var deactivate = react_1.useCallback(function () {
        panelApi.deactivate();
    }, []);
    var activate = function (config) {
        var content = render({ deactivate: deactivate, data: config === null || config === void 0 ? void 0 : config.data });
        if (!content) {
            return;
        }
        panelApi.activate(react_1.default.createElement(SidePanel_1.SidePanel, {
            title: (config === null || config === void 0 ? void 0 : config.title) || title,
            description: (config === null || config === void 0 ? void 0 : config.description) || description,
            onRequestClose: function () {
                deactivate();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }, content), { isShrink: shrink });
    };
    return {
        activate: activate,
        deactivate: deactivate,
        isShown: !!panelApi.element
    };
}
exports.usePageWizardPanel = usePageWizardPanel;
//# sourceMappingURL=hooks.js.map